import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { buildNavigationUrl } from '../../../build-your-cover/utils/navigation';
import { STEP_SLUG } from '../../../build-your-cover/constants';
import type { CustomerProductType } from '../../../../types/state/customer';

export type RefinePriceProductType = CustomerProductType;

const productTypeUrlMap = {
  [PRODUCT_TYPE.PACKAGE]: buildNavigationUrl(STEP_SLUG.HOSPITAL, PRODUCT_TYPE.PACKAGE),
  [PRODUCT_TYPE.COMBINED]: buildNavigationUrl(STEP_SLUG.HOSPITAL, PRODUCT_TYPE.PACKAGE),
  [PRODUCT_TYPE.EXTRAS]: buildNavigationUrl(STEP_SLUG.EXTRAS, PRODUCT_TYPE.EXTRAS),
  [PRODUCT_TYPE.HOSPITAL]: buildNavigationUrl(STEP_SLUG.HOSPITAL, PRODUCT_TYPE.HOSPITAL),
};

const getDestinationUrl = (productType: keyof typeof productTypeUrlMap) => productTypeUrlMap[productType];

export default getDestinationUrl;
